<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="moldNo"
    item-value="moldNo"
    :label="label"
    :disabled="disabledComputed"
    :loading="loading"
    :required="requiredComputed"
    :isSelectedAuto="false"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'MoldNoInput',

  mixins: [APIUtils, Message],
  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0051')
      },
    },
    ptCd: {
      type: String,
      required: true,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    requiredComputed() {
      let required = true
      if (this.disabledComputed) {
        required = false
      }
      return required
    },
    disabledComputed() {
      let disabled = false
      if (this.items.length == 0) {
        disabled = true
      }
      return disabled
    },
  },

  watch: {
    async ptCd(value) {
      await this.setMolds(value)
    },
  },

  methods: {
    onChange(value) {
      const select = this.items.find((v) => v.moldNo == value)
      if (select != undefined) {
        this.$emit('inputModel', select)
      } else {
        this.$emit('inputModel', null)
      }
    },

    async setMolds(ptCd) {
      this.loading = true
      this.items = []

      try {
        if (ptCd) {
          let params = { ptCd: ptCd }
          if (this.validOnly) {
            params.validOnly = true
          }

          const elements = await API.get('/master/pts', params)
          for (let idx = 0; idx < elements.length; idx++) {
            if (elements[idx].moldNo) {
              this.items.push(elements[idx])
            }
          }
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0059') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setMolds(this.ptCd)
  },
}
</script>
